import React from "react";
import styles from "./LanguageSelection.module.scss";
import Cancel from "../../components/icons/Cancel";
import { getSupportedLocale, localeComparator } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import api from "../../axiosConfig";

export type LanguageSelectionProps = {
  close: () => void;
};

const LanguageSelection: React.FC<LanguageSelectionProps> = (props: LanguageSelectionProps) => {
  const { i18n } = useTranslation();
  const [locales, setLocales] = React.useState([] as Api.Locale[]);
  const [fetchingLocales, setFetchingLocales] = React.useState(false);
  const { t } = useTranslation();
  React.useEffect(() => {
    if (locales.length === 0 && !fetchingLocales) {
      setFetchingLocales(true);
      api.get("localizationids").then((res: any) => {
        setLocales(res.data);
        // Set I18n language to "the supported best guess"
        const locale = getSupportedLocale(i18n.language, res.data as Api.Locale[]);
        if (!!locale && locale.locale !== i18n.language) {
          i18n.changeLanguage(locale.locale);
        }
        setFetchingLocales(false);
      });
    }
  });

  return (
    <div className={styles.LanguageSelectionOpen}>
      <>
        <div className={styles.headerRow}>
          <h1>{t("select_language")}</h1>
          <div className={styles.Cancel} onClick={() => props.close()}>
            <Cancel />
          </div>
        </div>
        <div className={styles.LanguageList}>
          <ul data-tag="languageList">
            {locales.sort(localeComparator()).map(locale => {
              return (
                <li
                  key={locale.locale}
                  className={i18n.language === locale.locale ? styles.languageSelected : ""}
                  onClick={() => {
                    i18n.changeLanguage(locale.locale);
                    setTimeout(() => props.close(), 500);
                  }}
                >
                  {locale.friendlyName}
                </li>
              );
            })}
          </ul>
        </div>
      </>
    </div>
  );
};

export default LanguageSelection;
